import { registerAction } from '../../Action'
import { workflowActions } from '../workflowActions'

const fetchWorkflowAction = registerAction(
  workflowActions.FETCH_WORKFLOW_BY_CONTEXT,
  { reducer: null }
)

export default fetchWorkflowAction
